import RefappFaq from './directives/RefappFaq';
import './styles/entry.scss';

export default {
  install(app) {
    app.directive('refapp-faq', RefappFaq);
  },
};
